import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SupplierReducer(state = initialState.supplier, action: any) {
  switch (action.type) {
    case types.SAVE_SUPPLIER_SUCCESS:
      return action.supplier;
    default:
      return state;
  }
}
